var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/images/empty.svg'),expression:"'/static/images/empty.svg'"}],attrs:{"alt":"empty image"}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }